export const GET_HOW_ITS_WORKS_STEPS = "GET_HOW_ITS_WORKS_STEPS";

export const getHowItWorksSteps = (payload) => {
  return {
    type: GET_HOW_ITS_WORKS_STEPS,
    payload,
  };
};
